import React from 'react';
import { ButtonGroup, CancelButton, PrimaryButton, StyledModal } from '../HybridMailStyles';
import { useHybridMail } from '../HybridMailContext';
import Step5Scheduling from '../../BatchJobs/components/Step5Scheduling';
import { BatchJobProvider, useBatchJob } from '../../../../../context/BatchJobContext';
import { HYBRID_MAIL, HYBRID_MAIL_ROOM } from '../TranslationValue';

const SchedulingModalContent = ({ t, batchId, onCancel, handleCurrentPage }) => {
  const { handleHybridSubmit, isHybridSubmitting, canProceed } = useBatchJob();

  const cb = () =>{
    onCancel();
    setTimeout(() => {
      handleCurrentPage('dashboard');
    }, 500);
    
  }

  return (
    <div style={{ padding: '20px' }}>
      <Step5Scheduling />
      <ButtonGroup
        style={{ marginTop: '20px', justifyContent: 'flex-end', display: 'flex', gap: '10px' }}
      >
        <CancelButton onClick={onCancel}>
          {t(HYBRID_MAIL_ROOM.CANCEL_BUTTON.key, HYBRID_MAIL_ROOM.CANCEL_BUTTON.value)}
        </CancelButton>
        <PrimaryButton loading={isHybridSubmitting} onClick={() => handleHybridSubmit(batchId, cb)}>
        {isHybridSubmitting ?t(HYBRID_MAIL.SUBMITTING_BATCH.key, HYBRID_MAIL.SUBMITTING_BATCH.value) : t(HYBRID_MAIL.SUBMIT_BATCH.key, HYBRID_MAIL.SUBMIT_BATCH.value)}
        </PrimaryButton>
      </ButtonGroup>
    </div>
  );
};

const SchedulingModal = () => {
  const {
    batchId,
    handleCurrentPage,
    isSchedulingModalVisible,
    setIsSchedulingModalVisible,
    onRefresh,
    t,
  } = useHybridMail();

  const handleCancel = () => setIsSchedulingModalVisible(false);

  return (
    <StyledModal
      visible={isSchedulingModalVisible}
      onCancel={handleCancel}
      footer={null}
      width={800}
      destroyOnClose
    >
      <BatchJobProvider
        onBatchCreated={() => {
          setIsSchedulingModalVisible(false);
          onRefresh && onRefresh();
        }}
        onReturn={() => setIsSchedulingModalVisible(false)}
      >
        <SchedulingModalContent batchId={batchId} onCancel={handleCancel} t={t} handleCurrentPage={handleCurrentPage} />
      </BatchJobProvider>
    </StyledModal>
  );
};

export default SchedulingModal;
